import { Observable } from 'rxjs';

export interface resetBalanceParams {
    confirmation_code?: string,
    from_account_id: number,
}

export interface AdminCustomerAccountFacade {
  getAssetUserTxt(clientId: string): Observable<Blob>;

  userWalletRebalance(params: resetBalanceParams): Observable<any>;
}
